import { render, staticRenderFns } from "./MinorConfirmMobileToken.vue?vue&type=template&id=da4d1b42&"
import script from "./MinorConfirmMobileToken.vue?vue&type=script&lang=js&"
export * from "./MinorConfirmMobileToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports